import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useMediaQuery } from 'react-responsive';
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';

const LoupeLikertItemSliderComponent = props => {

    const currentItem = props.currentItem;
     
    const [value, setValue] = React.useState(currentItem.selectedValue);

    const handleChange = (event, newValue) => {
        currentItem.validator.touched();
        currentItem.selectedValue = newValue;
        setValue(newValue);

        if(currentItem.validator.instantRevalidation) {
            currentItem.validator.revalidate();
        }
    };


    return(
        <div>
            
            <LoupeItemHeaderComponent currentItem={currentItem} />

            <Grid container>
                <Grid item xs/>
                <Grid item xs={8}>
                    <Slider                     
                        {...( currentItem.sliderType == "discrete" ? currentItem.lockMarks == false ? {  step : currentItem.increment} : { step : null} : {} )}
                        marks={currentItem.marks}
                        onChange={handleChange}
                        value={value}
                        track={false}
                        min={currentItem.minValue}
                        max={currentItem.maxValue}
                        valueLabelDisplay={currentItem.labelDisplayProperty} />
                </Grid>
                <Grid item xs/>
            </Grid>
        </div>
    );

}
export default LoupeLikertItemSliderComponent;